import type { ReactNode } from "react";

export const ListItemMeta = ({ title, children }: { title: ReactNode; children: ReactNode }) => (
    <div className="ant-list-item-meta">
        <div className="ant-list-item-meta-content">
            <h3 className="ant-list-item-meta-title">{title}</h3>
            <div className="ant-list-item-meta-description">{children}</div>
        </div>
    </div>
);

export const CardHeading = ({ children }: { children: ReactNode }) => (
    <h2 className="ant-card-head-title" style={{ margin: 0 }}>
        {children}
    </h2>
);
